import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="pt-32 pb-16 px-4 md:pt-40 md:pb-24 max-w-4xl mx-auto text-center" data-id="element-54">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} data-id="element-55">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-brand-navy leading-tight mb-6" data-id="element-56">
          "Cómo Recuperar la Atención de tu Hijo y Eliminar los Berrinches por
          Pantallas en solo 21 Días Sin Gritos, Sin Dramas y Sin Sentirte una
          Mala Madre"
        </h1>

        <p className="text-xl md:text-2xl text-brand-navy/80 italic mb-10 font-serif" data-id="element-57">
          — Incluso Si hoy parece "imposible" quitarle la tablet sin que la casa
          se caiga abajo.
        </p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.3
      }} className="mb-12" data-id="element-58">
          <img src="https://cdn.magicpatterns.com/uploads/sTz38MzWAkX1ii4vougr5G/heylloyd-image-1775249726906.png" alt="RESET DIGITAL — Ebook, guías y bonos incluidos" className="mx-auto w-full max-w-lg md:max-w-xl rounded-2xl drop-shadow-2xl" data-id="element-59" />
        </motion.div>

        <div className="bg-brand-muted p-6 md:p-8 rounded-2xl mb-12 shadow-sm border border-brand-navy/5" data-id="element-60">
          <p className="text-lg md:text-xl text-brand-navy leading-relaxed" data-id="element-61">
            ¿Sientes que estás perdiendo a tu hijo frente a un algoritmo?
            Descubre el{' '}
            <strong className="text-brand-teal" data-id="element-62">
              Protocolo Neuro-Conductual
            </strong>{' '}
            que está ayudando a miles de padres en LATAM a "resetear" el cerebro
            de sus hijos y recuperar la paz en casa.
          </p>
        </div>

        <div className="max-w-2xl mx-auto" data-id="element-63">
          <CTAButton data-id="element-64" />
          <p className="mt-4 text-sm text-brand-navy/60 flex items-center justify-center gap-2" data-id="element-65">
            <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse" data-id="element-66"></span>
            Acceso inmediato. Pago 100% seguro.
          </p>
        </div>
      </motion.div>
    </section>;
}